import { render, staticRenderFns } from "./make-money.vue?vue&type=template&id=ae020dde&scoped=true&"
import script from "./make-money.vue?vue&type=script&lang=js&"
export * from "./make-money.vue?vue&type=script&lang=js&"
import style0 from "./make-money.vue?vue&type=style&index=0&id=ae020dde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae020dde",
  null
  
)

export default component.exports